//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { crawlProducts } from '@apis/universal-image-actions/universalImageActionsApi';
import PartialCuid from '@models/PartialCuid';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';
import { isTruthy } from '@utils/filterPredicates';
import { isValidUrlWithProtocol } from '@utils/urlValidation';

export const useGetCrawledProductsQuery = ({
  universalItemId,
  url,
}: {
  url: string;
  universalItemId: PartialCuid;
}) => {
  return useQuery({
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsProducts,
      QueryKeyConstants.UniversalImageActionsProductsCrawledProducts,
      url,
      universalItemId,
    ],
    queryFn: async ({ signal }) => {
      return crawlProducts({ url, universalItemId }, { signal });
    },
    staleTime: FIVE_MINUTES_STALE_TIME,
    enabled: isTruthy(url) && isValidUrlWithProtocol(url),
  });
};
